import styled, { css } from 'styled-components'

export const SelectContainer = styled.label<{ $isChecked?: boolean }>`
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 20px;
  cursor: pointer;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.grayscale.gray60};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  ${({ $isChecked }) =>
    $isChecked &&
    css`
      color: #172b4d;
    `};

  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  & span {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: transparent;
    border-radius: 50%;
    border: 2px solid #000;

    &:after {
      content: '';
      position: absolute;
      display: none;
    }
  }

  & span span {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 17px;
    width: 17px;
    background-color: transparent;
    border-radius: 50%;
    border: none;
  }

  &:hover input ~ span {
    border: 2px solid ${({ theme }) => theme.colors.brand.categoryBlue};
  }

  &:hover input ~ span span {
    background-color: ${({ theme }) => theme.colors.brand.categoryBlue};
  }

  & input:checked ~ span span {
    background-color: ${({ theme }) => theme.colors.brand.categoryBlue};
  }

  & span:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
`
